<template lang="html">
  <div class="panel-heading" :class="{'no-line': !hasToggle, 'is-expanded': expanded, 'is-collapsed': !expanded}" @click="toggle">
    <span class="icon" v-if="hasToggle">
      <i class="fa" :class="expanded ? 'fa-minus-square-o' : 'fa-plus-square-o'"/>
    </span>

    <slot name="mobile" v-if="isMobile && $slots.mobile"/>
    <slot v-else/>
  </div>
</template>

<script>

export default {

  data(){
    return this.$parent._data
  },

  computed: {
    isMobile(){
      return window.innerWidth <= 768
    },

    hasToggle(){
      if(!this.togglable && this.isMobile) return true
      return this.togglable
    }
  },

  methods: {
    toggle(){
      if(!this.isMobile) return
      this.expanded = !this.expanded
    }
  }
}
</script>

<style lang="scss" scoped>

@media screen and (min-width: 769px){
  .panel-heading{
    > span.icon{
      display: none;
    }
  }
}

@media screen and (max-width: 768px){
  .panel-heading{
    display: flex;
    align-items: center;

    span.icon{
      margin-left: -8px;
      margin-right: 5px;
      margin-top: 2px;
    }

    h1{
      display: inline;
      vertical-align: -4px;
    }

    &.is-collapsed{
      border-bottom-width: 3px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/panel/MobileToggle.vue